export default __webpack_public_path__ + "static/media/thumb-hand.7497d426.png";